/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { MAX_VIEW_WIDTH } from "../styles"

export const ContentArea = ({ children, ...restProps }) => {
  return (
    <div css={{ ...MAX_VIEW_WIDTH, margin: "auto" }} {...restProps}>
      {children}
    </div>
  )
}

export default ContentArea
